import React from "react";
import { Divider, Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import GetfVDateFormate from "../../../utils/Genaricfunctions";

export default function VendorContactinformation(props) {
  const { t } = useTranslation();
  return (
    <>
      <Box className="mt-3 " sx={{ flexGrow: 1 }}>
        <Grid container spacing={{ xs: 2 }} columns={{ xs: 4, sm: 8, md: 12 }}>
          <Grid item xs={12} sm={4} md={4}>
            {/* General infomation */}
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "20px", backgroundColor: "#fff" }}>
              <span
                className="card-title "
                style={{
                  marginBottom: 10,
                  color: "#667085",
                  fontWeight: "bolder", fontSize: "larger"
                }}
              >
                {t('VendorDetails.label11')}

              </span>
              <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
              <h5
                className="card-subtitle"
                style={{
                  fontSize: "15px",
                  color: "#667085",
                  marginBottom: 5,
                  marginTop: 10,
                  fontWeight: 400,
                }}
              >
                <span style={{ marginRight: "auto" }}>{t('VendorDetails.label12')} </span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{props?.details?.taxID}</span>
              </h5>
              <h5
                style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }}
              >
                <span sx={{ marginRight: "auto" }}>{t('VendorDetails.label13')}</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }} hidden={!props?.details?.clientVendorRefId}>{props?.details?.clientVendorRefId}</span>
              </h5>
              <h5
                style={{ fontSize: "15px", color: "#667085", marginBottom: 5, fontWeight: 400, }}
              >
                <span sx={{ marginRight: "auto" }}>{t('VendorDetails.label14')}</span><span style={{ fontSize: "15px", color: "#101828", marginBottom: 5 }}>{GetfVDateFormate(props?.details?.prequalificationCreate)}</span>
              </h5>
            </Box>
          </Grid>
          {/* Address */}
          <Grid item xs={12} sm={4} md={4}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "20px", backgroundColor: "#fff" }}>
              <span
                className="card-title "
                style={{
                  marginBottom: 10,
                  color: "#667085",
                  fontWeight: "bolder", fontSize: "larger"
                }}
              >
                {t('VendorDetails.label15')}

              </span>
              <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
              <h5
                className="card-subtitle"
                style={{
                  fontSize: "15px",
                  color: "#667085",
                  marginBottom: 5,
                  marginTop: 10,
                  fontWeight: 400,
                }}
              >
                <span style={{ marginRight: "auto", color: "#101828" }}>
                  {props?.add?.address1},{props?.add?.address2}
                </span>
              </h5>

              <h5 style={{ fontSize: "15px", color: "#101828", marginBottom: 5, fontWeight: 400, }}>
                <span sx={{ marginRight: "auto", color: "#101828" }}>{props?.add?.city},{props?.add?.state}</span>
              </h5>

              <h5 style={{ fontSize: "15px", color: "#101828", fontWeight: 400, marginBottom: 5 }}>
                <span sx={{ marginRight: "auto", color: "#101828" }}>{props?.add?.zip}</span>
              </h5>
            </Box>
          </Grid>

          {/* Contact Information */}
          <Grid item xs={12} sm={4} md={4}>
            <Box border={1}
              borderLeft={1}
              borderRight={1}
              borderColor="#e4e7ec" sx={{ padding: "20px", backgroundColor: "#fff" }}>
              <span
                className="card-title "
                style={{
                  marginBottom: 10,
                  color: "#667085",
                  fontWeight: "bolder", fontSize: "larger"
                }}
              >
                {t('VendorDetails.label16')}

              </span>
              <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
              <h5
                className="card-subtitle"
                style={{
                  fontSize: "15px",
                  color: "#667085",
                  fontWeight: 400,
                  marginBottom: 5,
                  marginTop: 10,
                }}
              >
                <span style={{ marginRight: "auto" }}> {t('VendorDetails.label17')}</span><span style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5 }}>{props?.contact?.phoneNumber}</span>
              </h5>
              <h5 style={{ fontSize: "15px", color: "#667085", fontWeight: 500, marginBottom: 5 }}>
                <span sx={{ marginRight: "auto" }}> {t('VendorDetails.label18')}</span><span style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5 }}>{props?.contact?.faxNumber}</span>
              </h5>
              <h5 style={{ fontSize: "15px", color: "#667085", fontWeight: 500, marginBottom: 5 }}>
                <span sx={{ marginRight: "auto" }}> {t('VendorDetails.label19')}</span><a style={{ fontSize: "15px", color: "#2A93DB", marginBottom: 5, textDecoration: "none", corser: "pointer" }} target="_blank" href={"https://" + props?.contact?.websiteURL}>{props?.contact?.websiteURL}</a>
              </h5>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
